import axios, { AxiosResponse } from 'axios'
import qs from 'qs'

export async function getSpamContent ({ page, pageSize } : Pagination = { page: 1, pageSize: 25 }) {
  const response: AxiosResponse = await axios.get(
    `/community/api/spamContent${qs.stringify({ page, pageSize }, { addQueryPrefix: true })}`
  )
  if (response.data) {
    const { result, _metadata: { totalCount: total } } = response.data
    response.data = { result, total }
    return response
  }

  return response
}

export async function getSpamContentCount () {
  return await axios.get(`/community/api/spamContent/count`)
}
